<template>
  <section>
    <THeading
      :level="3"
      tag="h3"
      class="mb-4"
    >
      {{ t('title') }}
    </THeading>

    <TGrid has-vertical-gap>
      <template v-for="bedType in BED_TYPES">
        <TGridItem
          v-if="accommodations[bedType] > 0"
          :key="bedType"
          :cols="6"
          :lg="4"
        >
          <div class="flex">
            <div class="mr-4">
              <TIcon
                :icon="['fal', lookupBedTypeIcon(bedType)]"
                size="2xl"
                fixed-width
                class="mt-2"
              />
            </div>
            <div>
              <div class="font-semibold">
                {{ t(`${bedType}.quantity`, accommodations[bedType]) }}
              </div>
              <div class="text-gray-500">
                {{ t(`${bedType}.description`) }}
              </div>
            </div>
          </div>
        </TGridItem>
      </template>
    </TGrid>
  </section>
</template>

<script setup lang="ts">
import { BED_TYPES } from '~/constants/rv'

defineProps<{
  accommodations: Record<BED_TYPES, number>
}>()

const { t } = useI18n()
</script>

<i18n src="~~/i18n/locales/common/rv/accommodations.json" lang="json" />

<i18n lang="json">
{
  "en": {
    "title": "Accommodations"
  },
  "fr": {
    "title": "Mobilier de couchage"
  }
}
</i18n>
